import "./radio.scss";

type ToggleButtonProps = {
  label: string;
  required?: boolean;
  name: string;
  options: { label: string; value: string | number }[];
  selectedValue: string | number;
  handleChange: (value: string) => void;
  className?: string;
  onTabClick?: () => void;
  disabled?: boolean;
};

export const ToggleButtons = ({
  label,
  required = false,
  name,
  options,
  selectedValue,
  handleChange,
  className,
  onTabClick,
  disabled = false,
}: ToggleButtonProps) => {
  return (
    <div
      className={`${className} toggle-buttons-group ${
        disabled ? "opacity-50" : ""
      }`}
    >
      <label className="toggle-buttons-label">
        <span>{label}</span> {required && <span className="required">*</span>}
      </label>
      <div className="toggle-buttons">
        {options.map((option) => (
          <label
            key={option.value}
            className={`toggle-button ${
              selectedValue === option.value ? "activeBg" : ""
            } ${disabled ? "disabled" : ""}`}
            onMouseDown={() => !disabled && onTabClick?.()}
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={selectedValue === option.value}
              onChange={(e) => {
                if (!disabled) {
                  handleChange(e.target.value);
                }
              }}
              disabled={disabled}
            />
            {option.label}
          </label>
        ))}
      </div>
    </div>
  );
};

export default ToggleButtons;
